<div class="booking-navbar">
    <header class="booking-header">
        <nav class="booking-nav">
            <!-- Logo y marca -->
            <div class="nav-brand">
                <a routerLink="/" class="brand-link">
                    <span class="brand-text">Eco-Turismo</span>
                </a>
            </div>

            <!-- Navegación principal -->
            <div class="nav-main">
                <div class="nav-categories">
                    <a routerLink="/superadmin" class="nav-category">
                        <svg class="category-icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                        </svg>
                        Inicio
                    </a>
                    <a routerLink="/allhostings" class="nav-category">
                        <svg class="category-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
                            <path d="M4 10.5L12 4L20 10.5M6.5 9.5V19.5H17.5V9.5M10 19.5V14.5H14V19.5"
                                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        Ver alojamientos
                    </a>
                    <a href="/create-hosting" class="nav-category">
                        <svg class="category-icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
                        </svg>
                        Crear Alojamiento
                    </a>
                    <a routerLink="/create-admin" class="nav-category">
                        <svg class="category-icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                            <path
                                d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z" />
                        </svg>

                        Crear Administrador
                    </a>
                </div>
            </div>

            <!-- Botones de usuario -->
            <div class="nav-user">
                <div class="user-actions">
                    @if (!isLoggedIn) {
                    <button routerLink="/loggin" class="btn-login">Log in →</button>
                    }
                    @if (isLoggedIn) {
                    <div class="user-dropdown">
                        <button class="user-avatar">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                <path
                                    d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                            </svg>
                        </button>
                        <div class="dropdown-menu">
                            <button (click)="signOut()" class="dropdown-item">Log out →</button>
                        </div>
                    </div>
                    }
                </div>
            </div>

            <!-- Botón menú móvil -->
            <div class="mobile-toggle">
                <button (click)="toggleMobileMenu()" class="mobile-menu-btn">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
                    </svg>
                </button>
            </div>
        </nav>

        <!-- Menú móvil -->
        <div [class.show]="mobileMenuOpen" class="mobile-menu">
            <div class="mobile-menu-content">
                <div class="mobile-header">
                    <span class="mobile-brand">Eco-Turismo</span>
                    <button (click)="toggleMobileMenu()" class="mobile-close">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                            <path
                                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </svg>
                    </button>
                </div>
                <div class="mobile-categories">
                    <a routerLink="/" class="mobile-category">Inicio</a>
                    <a routerLink="/hostinglist" class="mobile-category">Habitaciones</a>
                    <a href="#" class="mobile-category">Experiencias</a>
                    <a href="#" class="mobile-category">Contacto</a>
                    @if (isLoggedIn) {
                    <a routerLink="/my-reservations" class="mobile-category">Mis Reservas</a>
                    }
                    <a href="#" class="mobile-category">Reserva ahora</a>
                </div>
                <div class="mobile-user">
                    @if (!isLoggedIn) {
                    <button routerLink="/loggin" class="mobile-btn-login">Log in</button>
                    }
                    @if (isLoggedIn) {
                    <button (click)="signOut()" class="mobile-category">Log out</button>
                    }
                </div>
            </div>
        </div>
    </header>
</div>